import React, { FC, Fragment, useMemo } from 'react';
import htmlParser from 'html-react-parser';
import { Shortcode, isShortCodeLink } from './models';
import { JShortcodeLink } from './components';
import jsonpath from 'jsonpath';



export const JShortcodeParser: FC<{ html: string }> = ({ html }) => {
    const nodes: JSX.Element[] = useMemo(() => shortcodeParser(html), [html])
    return (
        <Fragment>
            {
                nodes
            }
        </Fragment>
    )
}
function matchAllToArray(regex: RegExp, str: string) {
    return Array.from(str.matchAll(regex)).filter(m => m.index !== undefined)
}

export function shortcodeParser(str: string){
    const data: JSX.Element[] = []
    const matches = matchAllToArray(/\[\[(.*?)\]\]/g, str)

    if (!matches.length) return [htmlParser(str) as JSX.Element]

    let i = 0;

    for (const { 0: match, 1: content, index } of matches) {
        if (index !== undefined) {

            data.push(htmlParser(str.substring(i, index)) as JSX.Element)


            const shortCode: Shortcode = {
                type: content.split(' ')[0] as Shortcode['type']
            }


            for (const [, key, value] of matchAllToArray(/([^\s]*?)=`(.*?)`/g, content)) {
                if (key.indexOf('.') > 0) {
                    jsonpath.value(shortCode, `$.${key}`, value)
                } else {
                    shortCode[key] = value
                }
            }

            if (isShortCodeLink(shortCode)) {
                data.push(<JShortcodeLink {...shortCode} />)
            } else if (shortCode.title) {
                console.warn(`Unrecognized shortcode: ${JSON.stringify(shortCode, null, 4)}`)
                data.push(<span>{shortCode.title}</span>)
            }

            i = index + match.length

        }
        if(i < str.length) {
            data.push(htmlParser(str.substring(i, str.length)) as JSX.Element)
        }
    }
    return data

}